import React, { useState, useEffect } from 'react';

const ImageSlider = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [previousIndex, setPreviousIndex] = useState(0);

  const images = [
  "https://cdn.pixabay.com/photo/2017/09/21/13/32/girl-2771936_1280.jpg",
  "https://cdn.pixabay.com/photo/2020/07/08/04/12/work-5382501_1280.jpg",
  "https://cdn.pixabay.com/photo/2018/03/10/12/00/teamwork-3213924_1280.jpg",
  "https://cdn.pixabay.com/photo/2021/11/21/06/28/quality-6813293_1280.jpg",
  "https://cdn.pixabay.com/photo/2017/08/06/22/01/books-2596809_1280.jpg",
  "https://cdn.pixabay.com/photo/2015/01/08/18/29/entrepreneur-593358_1280.jpg"
];

const imageTexts = [
  {
    bgText: "EDUCATION",
    mainTitle: "Student Migration Tracking System",
    subText:
      "A smart initiative by the Andhra Pradesh Government to monitor and support student migration for higher education and skill development."
  },
  {
    bgText: "DIGITAL",
    mainTitle: "Empowering Students Through Technology",
    subText:
      "Connecting students with digital learning platforms, career opportunities, and transparent educational services across Andhra Pradesh."
  },
  {
    bgText: "CAREERS",
    mainTitle: "Building Future Opportunities",
    subText:
      "Helping students identify academic pathways, employment opportunities, and migration trends for better career planning."
  },
  {
    bgText: "LEARNING",
    mainTitle: "Quality Education for Every Student",
    subText:
      "Ensuring access to quality education, student welfare tracking, and institutional support through modern governance systems."
  },
  {
    bgText: "INNOVATION",
    mainTitle: "Modern Educational Ecosystem",
    subText:
      "Promoting innovation, research, and academic excellence through student-centric educational initiatives in Andhra Pradesh."
  },
  {
    bgText: "ANDHRA",
    mainTitle: "Andhra Pradesh Student Development Portal",
    subText:
      "An integrated platform focused on student mobility, higher education access, and skill enhancement for the youth of Andhra Pradesh."
  }
];

    useEffect(() => {
        const interval = setInterval(() => {
            setPreviousIndex(currentIndex);
            setCurrentIndex(prevIndex =>
                prevIndex === images.length - 1 ? 0 : prevIndex + 1
            );
        }, 5000);

        return () => clearInterval(interval);
    }, [currentIndex, images.length]);

    return (
        <section className="image-slider-section">
            <div className="slider-container">
                {images.map((image, index) => (
                    <div
                        key={index}
                        className={`slider-image ${index === currentIndex ? 'active' : ''} ${index === previousIndex ? 'previous' : ''}`}
                        style={{ backgroundImage: `url(${image})`, backgroundRepeat: 'no-repeat' }}
                    >
                        <div className="overlay"></div>

                        {index === currentIndex && (
                            <div className="text-wrapper">

                                <h1 className="bg-text slide-left">
                                    {imageTexts[currentIndex].bgText}
                                </h1>

                                <h2 className="main-title slide-right">
                                    {imageTexts[currentIndex].mainTitle}
                                </h2>

                                <p className="sub-text fade-up">
                                    {imageTexts[currentIndex].subText}
                                </p>

                            </div>
                        )}
                    </div>
                ))}
            </div>

            <style>{`
                /* Make section take full viewport width */
                .image-slider-section {
                    width: 100vw;
                    margin-left: calc(-50vw + 50%);
                    margin-right: calc(-50vw + 50%);
                    position: relative;
                    overflow-x: hidden;
                }

                /* TEXT WRAPPER */
                .text-wrapper {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    text-align: center;
                    width: 80%;
                    z-index: 10;
                }

                /* BG TEXT behind main title */
                .bg-text {
                    position: absolute;
                    inset: 0;                       
                    display: flex;
                    align-items: center;            
                    justify-content: center;       
                    font-size: 150px;
                    font-weight: 900;
                    color: rgba(255, 255, 255, 0.2);
                    letter-spacing: 8px;
                    pointer-events: none;
                    white-space: nowrap;
                    z-index: 1;                   
                }

                /* MAIN TITLE - sits directly on top */
                .main-title {
                    top: 20px;
                    position: relative;
                    font-size: 50px;
                    font-weight: 800;
                    color: #fff;
                    margin: 0;
                    z-index: 2;
                }

                /* SUB TEXT - below main title */
                .sub-text {
                    top: 23px;
                    position: relative;
                    color: #eee;
                    font-size: 20px;
                    margin-top: 20px;
                    max-width: 700px;
                    margin-left: auto;
                    margin-right: auto;
                    z-index: 2;
                }

                /* slide from left */
                .slide-left {
                    animation: slideLeft 2s ease forwards;
                }

                @keyframes slideLeft {
                    0% {
                        transform: translateX(-100%);
                        opacity: 0;
                    }
                    100% {
                        transform: translateX(0);
                        opacity: 1;
                    }
                }

                /* ---------------------- */
                /*      MAIN TITLE        */
                /* ---------------------- */
                .main-title {
                    font-size: 52px;
                    font-weight: 800;
                    color: #fff;
                    margin: 10px 0 0 0;
                    opacity: 0;
                }

                /* slide from right */
                .slide-right {
                    animation: slideRight 2s ease forwards;
                }

                @keyframes slideRight {
                    0% {
                        transform: translateX(120%);
                        opacity: 0;
                    }
                    60% { opacity: 0.4; }
                    100% {
                        transform: translateX(0);
                        opacity: 1;
                    }
                }

                /* ---------------------- */
                /*       SUB TEXT         */
                /* ---------------------- */
                .sub-text {
                    color: #e8e8e8;
                    width: 60%;
                    margin: 20px auto 0 auto;
                    font-size: 20px;
                    line-height: 1.5;
                    opacity: 0;
                }

                /* fade + move up */
                .fade-up {
                    animation: fadeUp 2s ease forwards;
                }

                @keyframes fadeUp {
                    0% {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    100% {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                /* Increase Height */
                .slider-container {
                    width: 100%;
                    height: 100vh;
                    overflow: hidden;
                    position: relative;
                }

                /* Background Image */
                .slider-image {
                    width: 100%;
                    height: 100%;
                    background-size: cover;
                    background-position: center;
                    position: absolute;
                    top: 0;
                    left: 0;
                    opacity: 0;
                    transform: scale(1);
                }

                /* Active slide - visible and zooming */
                .slider-image.active {
                    opacity: 1;
                    animation: zoomIn 5s linear forwards;
                }

                /* Previous slide - fading out with maintained zoom */
                .slider-image.previous:not(.active) {
                    opacity: 1;
                    transform: scale(1.1);
                    animation: fadeOut 1.2s ease-in-out forwards;
                }

                /* Continuous slow zoom in effect */
                @keyframes zoomIn {
                    0% { 
                        transform: scale(1);
                    }
                    100% { 
                        transform: scale(1.1);
                    }
                }

                /* Fade out while maintaining the zoomed state */
                @keyframes fadeOut {
                    0% { 
                        opacity: 1;
                        transform: scale(1.1);
                    }
                    100% { 
                        opacity: 0;
                        transform: scale(1.1);
                    }
                }

                /* Overlay */
                .overlay {
                    position: absolute;
                    inset: 0;
                    background: rgba(0, 0, 0, 0.4);
                }

                /* Responsive Design */
                @media (max-width: 768px) {
                    .bg-text {
                        font-size: 60px;
                        letter-spacing: 4px;
                        white-space: normal;
                        word-break: break-word;
                    }
                    
                    .main-title {
                        font-size: 28px;
                    }
                    
                    .sub-text {
                        font-size: 14px;
                        width: 90%;
                    }
                    
                    .text-wrapper {
                        width: 95%;
                    }
                }

                @media (max-width: 480px) {
                    .bg-text {
                        font-size: 40px;
                    }
                    
                    .main-title {
                        font-size: 22px;
                    }
                    
                    .sub-text {
                        font-size: 12px;
                    }
                }
            `}</style>
        </section>
    );
};

export default ImageSlider;